import React from 'react';
// core components
import Button from "app/components/CustomButtons/Button.js";

export class FormCOL extends React.Component {

    state = {
        rows: [{}]
    };

    handleChange = idx => e => {
        const { name, value } = e.target;
        const rows = [...this.state.rows];
        rows[idx] = {
            [name]: value
        };
        this.setState({
            rows
        });
    };
    handleAddRow = (e) => {
        const item = {
            itemCode: "",
            quantity: "",
            description: "",
            rangeDescription: "",

        };
        this.setState({
            rows: [...this.state.rows, item]
        });
        e.preventDefault();
    };
    handleRemoveSpecificRow = (idx) => (e) => {
        const rows = [...this.state.rows]
        rows.splice(idx, 1)
        this.setState({ rows })
        e.preventDefault();
    }
    render() {
        return (
            <div>
                <div className="container">
                    <div className="row clearfix">
                        <div className="col-md-12 column">
                            <table
                                className="table table-bordered table-hover"
                                id="tab_logic">
                                <thead>
                                    <tr>
                                        <th className="text-center">Item Code </th>
                                        <th className="text-center">Quantity</th>
                                        <th className="text-center">Description</th>
                                        <th className="text-center">Other Comments</th>
                                        <th className="text-center">Number Of Pallets</th>
                                        <th className="text-center">Units Per Pallet</th>
                                        <th className="text-center">Total Pieces</th>
                                        <th />
                                    </tr>
                                </thead>
                                <tbody>
                                    {this.state.rows.map((item, idx) => (
                                        <tr id="addr0" key={idx}>
                                            <td>
                                                <input
                                                    type="text"
                                                    name={"itemCode" + idx}
                                                    value={this.state.rows[idx].itemCode}
                                                    onChange={this.handleChange(idx)}
                                                    className="form-control"
                                                />
                                            </td>
                                            <td>
                                                <input
                                                    type="text"
                                                    name={"quantity" + idx}
                                                    value={this.state.rows[idx].quantity}
                                                    onChange={this.handleChange(idx)}
                                                    className="form-control"
                                                />
                                            </td>
                                            <td>
                                                <input
                                                    type="text"
                                                    name={"description" + idx}
                                                    value={this.state.rows[idx].description}
                                                    onChange={this.handleChange(idx)}
                                                    className="form-control"
                                                />
                                            </td>
                                            <td>
                                                <input
                                                    type="text"
                                                    name={"rangeDescription" + idx}
                                                    value={this.state.rows[idx].rangeDescription}
                                                    onChange={this.handleChange(idx)}
                                                    className="form-control"
                                                />
                                            </td>
                                            <td>
                                                <input
                                                    type="text"
                                                    name={"numberOfPallets" + idx}
                                                    value={this.state.rows[idx].quantity}
                                                    onChange={this.handleChange(idx)}
                                                    className="form-control"
                                                />
                                            </td>
                                            <td>
                                                <input
                                                    type="text"
                                                    name={"unitsPerPallet" + idx}
                                                    value={this.state.rows[idx].quantity}
                                                    onChange={this.handleChange(idx)}
                                                    className="form-control"
                                                />
                                            </td>
                                            <td>
                                                <input
                                                    type="text"
                                                    name={"totalPieces" + idx}
                                                    value={this.state.rows[idx].quantity}
                                                    onChange={this.handleChange(idx)}
                                                    className="form-control"
                                                />
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <Button onClick={this.handleAddRow} color="blue">
                                Add Row
                            </Button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
export default FormCOL;